
<div class="primary white--text" :class="dense ? 'mail-avatar-dense' : 'mail-avatar'">
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <div
                v-bind = "attrs"
                v-on   = "on"
            >
                {{ avatar }}
            </div>
        </template>

        <span>{{ sender }}</span>
    </v-tooltip>
</div>
